import { get_token } from '@/router/index.js';
import Swal from 'sweetalert2';

export const navbar_notification_action_methods = {
  mark_notification_read_url() {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/notification_management/mark_notification_as_read/`;
  },

  apply_mark_read_response(data, notification_id) {
    if (data.status === 'success') {
      this.apply_notification_read(notification_id);
    }
  },

  async mark_notification_read(notification_id) {
    const token = get_token();
    if (!token) return;

    try {
      const response = await fetch(this.mark_notification_read_url(), {
        method: 'POST',
        credentials: 'include',
        headers: this.authed_headers(token, true),
        body: JSON.stringify({ notification_id }),
      });

      if (!response.ok) return;

      this.apply_mark_read_response(await response.json(), notification_id);
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  },

  apply_notification_read(notification_id) {
    const notif = this.notifications.find(n => n.id === notification_id);
    if (notif) {
      notif.status = 'READ';
      notif.read_at = new Date().toISOString();
    }
    if (this.unread_count > 0) this.unread_count--;
  },

  apply_mark_all_read_response(data) {
    if (data.status === 'success') {
      this.apply_all_notifications_read();
    }
  },

  mark_all_read_url() {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/notification_management/mark_all_notifications_as_read/`;
  },

  async mark_all_read() {
    const token = get_token();
    if (!token) return;

    try {
      const response = await fetch(this.mark_all_read_url(), {
        method: 'POST',
        credentials: 'include',
        headers: this.authed_headers(token, true),
      });

      if (!response.ok) return;

      this.apply_mark_all_read_response(await response.json());
    } catch (error) {
      console.error('Error marking all as read:', error);
      this.$notyf?.error?.('Failed to mark all as read');
    }
  },

  apply_all_notifications_read() {
    this.$notyf?.success?.('All notifications marked as read');
    this.notifications.forEach(n => {
      n.status = 'READ';
      n.read_at = new Date().toISOString();
    });
    this.unread_count = 0;
  },

  async dismiss_notification(notification_id) {
    const result = await this.confirm_notification_dialog({
      title: 'Dismiss Notification?',
      text: 'Are you sure you want to dismiss this notification from your list?',
      confirmButtonText: 'Yes, dismiss!',
    });
    if (result.isConfirmed) await this.confirm_dismiss_notification(notification_id);
  },

  confirm_notification_dialog(options) {
    return Swal.fire({
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      ...options,
    });
  },

  dismiss_notification_url() {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/notification_management/dismiss_notification/`;
  },

  apply_dismiss_notification_response(data, notification_id) {
    if (data.status === 'success') {
      this.remove_dismissed_notification(notification_id);
    }
  },

  async confirm_dismiss_notification(notification_id) {
    const token = get_token();
    if (!token) return;

    try {
      const response = await fetch(this.dismiss_notification_url(), {
        method: 'POST',
        credentials: 'include',
        headers: this.authed_headers(token, true),
        body: JSON.stringify({ notification_id }),
      });

      if (!response.ok) return;

      this.apply_dismiss_notification_response(await response.json(), notification_id);
    } catch (error) {
      console.error('Error dismissing notification:', error);
    }
  },

  remove_dismissed_notification(notification_id) {
    const notif = this.notifications.find(n => n.id === notification_id);
    const was_unread = notif?.status !== 'READ';
    this.notifications = this.notifications.filter(n => n.id !== notification_id);
    if (was_unread && this.unread_count > 0) this.unread_count--;
  },

  async dismiss_all() {
    const result = await this.confirm_notification_dialog({
      title: 'Clear All Notifications?',
      text: 'Are you sure you want to clear all notifications?',
      confirmButtonText: 'Yes, clear!',
    });
    if (result.isConfirmed) await this.confirm_dismiss_all();
  },

  dismiss_all_notifications_url() {
    return `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/notification_management/dismiss_all_notifications/`;
  },

  apply_dismiss_all_response(data) {
    if (data.status !== 'success') return;

    this.$notyf?.success?.('All notifications cleared');
    this.notifications = [];
    this.unread_count = 0;
  },

  async confirm_dismiss_all() {
    const token = get_token();
    if (!token) return;

    try {
      const response = await fetch(this.dismiss_all_notifications_url(), {
        method: 'POST',
        credentials: 'include',
        headers: this.authed_headers(token, true),
      });

      if (!response.ok) return;

      this.apply_dismiss_all_response(await response.json());
    } catch (error) {
      console.error('Error dismissing all notifications:', error);
      this.$notyf?.error?.('Failed to clear notifications');
    }
  },

  handle_notification_click(notif) {
    if (notif.status !== 'READ') {
      this.mark_notification_read(notif.id);
    }
    if (notif.action_url) {
      this.push_notification_url(notif.action_url);
      return;
    }
    console.warn('No action_url found on this notification object.');
  },
};
